import { useEffect } from 'react';
import { useInfiniteReportGroups } from './useInfiniteReportGroups';

export const useEnsureSelectedGroupLoaded = ({ id, groupId }: { id?: string; groupId?: string }) => {
  const { groups, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } = useInfiniteReportGroups({ id });

  const isSelectedGroupLoaded = !groupId || groups.some(group => group.id === groupId);

  useEffect(() => {
    if (isLoading || isFetchingNextPage || isSelectedGroupLoaded || !hasNextPage) return;
    void fetchNextPage();
  }, [isLoading, isFetchingNextPage, isSelectedGroupLoaded, hasNextPage, fetchNextPage]);

  return { isResolvingSelectedGroup: !isSelectedGroupLoaded && (hasNextPage || isFetchingNextPage) };
};
